<template lang="pug">
.selector(:class="parameter")
  .selection
    .selection__inner
      template(v-if="selection")
        img.product-image(:src="selection.image")
        p.product-name {{ selection.name }}
      .base-image(v-else)
        .cable
  SelectionError(:visible="error", :text="errorText")

  SelectionAction(
    @open="open = true",
    @close="open = false",
    :actionText="actionText",
    :open="open",
    :error="error",
    :selected="!!selection",
    :products="cables",
    :parameter="parameter"
  )
</template>

<script>
import SelectionAction from "./SelectionAction";
import SelectionError from "./SelectionError";
import { mapGetters } from "vuex";
export default {
  name: "SelectorCable",
  props: ["parameter"],
  components: {
    SelectionAction,
    SelectionError,
  },
  data() {
    return {
      open: false,
      error: false,
      errorText: "",
    };
  },
  computed: {
    ...mapGetters(["cables", "model", "validity", "touched", "productLookup"]),
      selection() {
      const sku = this.model[this.parameter];
      if (sku) {
        return this.cables.find((c) => c.sku === sku);
      }
      return false;
    },
    actionText() {
      return `${
        this.selection
          ? '<i class="glyph-pencil"></i><span>Edit'
          : '<i class="glyph-add"></i><span>Choose'
      } Cable</span>`;
    },
  },
  methods: {
    isDisabledInChildren(cableSku) {
      const { connector_left, connector_right } = this.model;
      return [connector_left, connector_right]
        .filter(Boolean)
        .some((connSku) => {
          const connector = this.productLookup(connSku);
          if (!connector || !Array.isArray(connector.children)) return false;
          return connector.children.some(
            (child) =>
              child.category === "cable" &&
              Array.isArray(child.meta && child.meta.compatibility) &&
              child.meta.compatibility.includes(cableSku) &&
              child.disabled === true
          );
        });
    },
    handleError() {
      let error = false;
      let errorText = "";
      if (this.selection && this.isDisabledInChildren(this.selection.sku)) {
        error = true;
        errorText = "The desired configuration is out of stock.";
      } else if (this.selection && this.selection.disabled === true) {
        error = true;
        errorText = "The selected product is not currently available.";
      } else if (this.touched) {
        if (!this.selection) {
          error = true;
          errorText = "Please select a cable.";
        } 
        else if (!this.validity(this.selection)) {
          error = true;
          errorText =
            "This cable is not compatible one or more of your selected connectors.";
        }
      } else {
        if (this.selection && !this.validity(this.selection)) {
          error = true;
          errorText =
            "This cable is not compatible one or more of your selected connectors.";
        }
      }
      this.error = error;
      this.errorText = errorText;
    },
  },
  watch: {
    touched() {
      this.handleError();
    },
    model: {
      deep: true,
      handler() {
        this.handleError();
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.selector {
  display: flex;
  flex-direction: column;
  grid-area: span 1 / span 1;
}

.selection {
  border: 1px solid $midGray;
  overflow: hidden;
  position: relative;
  &::before {
    position: relative;
    display: block;
    content: "";
    //padding-top: calc(50% - 1px);
    padding-top: 100%;
    @include mq(md) {
      //padding-top: calc(40% - 1px);
      padding-top: 80%;
    }
  }

  &__inner {
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
  }
}

.product {
  &-image {
    padding: clamp(0.75rem, 3vw, 1.5rem);
    object-fit: scale-down;
    flex: 1 1 100%;
    margin-bottom: auto;
    max-height: 100%;
    margin: 0 auto;
    @include mq(md) {
      max-width: 200px;
    }
  }

  &-name {
    margin-top: auto;
    border-top: 1px solid lighten($midGray, 7%);
    flex: 0 0 auto;
    margin: 0;
    text-align: center;
    padding: 1rem 1.25rem;
    font-size: 0.75rem;
    @include mqdn(lg) {
      @include hideVisually;
    }
  }
}

.base-image {
  margin: auto;
  z-index: 0;
  position: relative;
  min-width: 2.75rem;
  width: 16.666%;
  max-width: 8rem;
  .selected & {
    display: none;
  }
  &::before {
    position: relative;
    display: block;
    content: "";
    padding-top: 87.5%;
  }

  .cable {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    &::before {
      content: "";
      height: 20%;
      background: $black;
      width: 50vw;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }
}
</style>